// extracted by mini-css-extract-plugin
export default {"banner":"OperationalBanner_banner__wo1IH"};